import { useSnackbar } from "notistack";

export const useShowSnackbar = () => {
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const addNotification = enqueueSnackbar;
  const removeNotification = closeSnackbar;

  return {
    addNotification,
    removeNotification
  };
};
